/**
 * Object of file fields in Vendor Application
 */

import { keyBy } from 'lodash';

export default keyBy([
  'w9_form',
  'w8_form',
  'w8ben_form',
  'w8bene_form',
  'vendor_agreement',
  'beauty_vendor_agreement',
  'certificate_of_insurance',
  'proposition65',
  'approval_signatures',
]);
